import React, { useEffect, useRef } from 'react';
import { string } from 'prop-types';

const YoutubeLoader = ({ ytId, src, className }) => {
  const iframeRef = useRef(null);
  const playerRef = useRef(null);

  useEffect(() => {
    const videoId = ytId || src.split('/').pop();
    (async () => {
      if (!playerRef.current) {
        if (!window.YT) {
          await new Promise((resolve) => {
            const tag = document.createElement('script');
            tag.src = 'https://www.youtube.com/iframe_api';
            const firstScriptTag = document.getElementsByTagName('script')[0];
            firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
            window.onYouTubeIframeAPIReady = resolve;
          });
        }

        playerRef.current = new window.YT.Player(iframeRef.current, {
          /* Override the default value 640. */
          width: '',
          /* Override the default value 390. */
          height: '',
          videoId,
        });
        return;
      }

      playerRef.current.cueVideoById(videoId);
    })();
  }, [ytId, src]);

  return (
    <div
      ref={(ref) => {
        if (!ref) return;
        iframeRef.current = ref;
        /* Set className with below as div className not work
        if set player width/height to emtpy string */
        iframeRef.current.className = className;
      }}
    />
  );
};

YoutubeLoader.propTypes = {
  ytId: string,
  src: string,
  className: string,
};

YoutubeLoader.defaultProps = {
  ytId: null,
  src: '',
  className: '',
};

export default YoutubeLoader;
